﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Page_Headline_Props } from '@Util/Types';

import { Plus_Button } from '@Elements/Buttons';
import { H1 } from '@Elements/Fonts';

export default function Page_Header(props: Page_Headline_Props): JSX.Element {
    return (
        <div className="Page_Header">
            {
                !str_isEmpty(props.headline) &&
                <H1>{props.headline}</H1>
            }
            {
                !str_isEmpty(props.button_aria_name) && props.button_action &&
                <>
                    <Plus_Button
                        onClick={props.button_action}
                        aria_name={props.button_aria_name}
                    />
                </>
            }
        </div>
    )
}